<!--  DEALER MAP  -->

<div class="map">
    <iframe [attr.src]="dealer.map_embed_link" class="google-map"></iframe>
</div>

<!--  END DEALER MAP  -->
